import { render, staticRenderFns } from "./course-cleanKeeping.vue?vue&type=template&id=f8bfab4e&scoped=true&"
import script from "./course-cleanKeeping.vue?vue&type=script&lang=js&"
export * from "./course-cleanKeeping.vue?vue&type=script&lang=js&"
import style0 from "./course-cleanKeeping.vue?vue&type=style&index=0&id=f8bfab4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bfab4e",
  null
  
)

export default component.exports